import React from 'react';

/**
 * A table cell component
 *
 * @displayName Td
 * @param {Object} props passed in properties
 * @returns {React.Element} Rendered Td
 * @extends React.Component
 */
export default (props) => <td { ...props }></td>;

